import React from "react";
import ScorecardsContent from "../../../../../CoachAI/shared/ScorecardsContent";

export default function ScorecardsTab({ report }) {
  return <ScorecardsContent reportData={report} />;
}
